/**
 * Copyright (c) 2015-2018, IGN France.
 * Copyright (c) 2018-2025, Giro3D team.
 * SPDX-License-Identifier: MIT
 */

import { Texture } from 'three';
export default class EmptyTexture extends Texture {
  isEmptyTexture = true;
  constructor() {
    super();
  }
}
export function isEmptyTexture(obj) {
  return obj?.isEmptyTexture;
}